import { reactive, computed } from '@vue/composition-api'
import * as _ from 'lodash'
import store from '@/store'

export const Checkbox = (props, context) => {
  const categories = computed(() => context.attrs.categories)
  const checked = computed(() => context.attrs.checked)

  const check = reactive({
    includeChildId: [],
    changeCheck: (e) => {
      const { target } = e
      const checked = target.checked
      const value = parseInt(target.value)

      // 子階層を含むIDを検索
      const aryIndex = _.findIndex(categories.value, (cat) => cat.id === value)
      const checkedCat = categories.value[aryIndex]
      check.includeChildId = []
      check.getChildrenId(checkedCat)
      const allId = check.includeChildId

      context.emit('checkSet', checked, value, allId)

      if (props.parentName === 'knowledge') {
        if (store.state.common.device === 'sp') {
          store.dispatch('common/showToast', { text: '絞り込み条件を変更しました' })
        }
      }
    },
    getChildrenId: (cat) => {
      check.includeChildId.push(cat.id)
      if (cat.children && cat.children.length > 0) {
        _.forEach(cat.children, (child) => check.getChildrenId(child))
      }
    }
  })

  const checkUpdate = (targetChecked, value, allId) => {
    // 自身の子階層の状態を確認する
    _.forEach(categories.value, cat => {
      if (cat.children && cat.children.length > 0) {
        if (targetChecked) {
          // 子要素がcheckedになったとき
          // 現在チェック中のものと、チェックが追加されたものを結合する
          const unionIds = _.union(checked.value, allId)
          /// union内に子要素のIDが全て含まれている場合は、親要素もチェック済みにする
          const allIncludes = _.every(cat.children, child => {
            return _.includes(unionIds, child.id)
          })
          if (allIncludes) {
            allId.push(cat.id)
          }
        } else {
          // 子要素のcheckがはずれたときは、親要素のチェックも外す
          _.forEach(cat.children, child => {
            if (_.includes(allId, child.id)) {
              allId.push(cat.id)
            }
          })
        }
      }
    })
    context.emit('checkSet', targetChecked, value, allId)
  }

  const isChecked = computed(() => {
    return (value) => checked.value.findIndex(item => item === Number(value)) > -1
  })

  return {
    categories,
    checked,
    checkUpdate,
    check,
    isChecked
  }
}
